module.exports = __webpack_public_path__ + "static/media/4.11a2d977.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/4.mp3
// module id = 83
// module chunks = 0